"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Triggers a callback as and when a user interacts outside the ref
 * @param ref - Ref to the object that won't trigger the callback when interacted with
 * @param cb - Callback to run when clicked outside
 * @returns function that when run removes the event listeners
 */
function onClickOutside(ref, cb) {
  var eventListeners = ['mousedown', 'touchstart', 'keydown']; // Allowed keys are space and esc

  var allowedKeys = [32, 27];

  var handleEvent = function handleEvent(event) {
    if (!ref || !event.target) return; // If its a keyboard event then check if its any keypress other than space
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    if (event !== null && event !== void 0 && event.keyCode && !allowedKeys.includes(event.keyCode)) return; // Do nothing if clicking ref's element or descendent elements

    if (ref.current && ref.current.contains(event.target)) {
      return;
    } // It has been clicked outside then call the callback


    cb(event);
  }; // Add the event listeners


  eventListeners.forEach(function (eventListener) {
    document.addEventListener(eventListener, handleEvent);
  }); // Return function to remove the event listeners

  return function () {
    eventListeners.forEach(function (eventListener) {
      document.removeEventListener(eventListener, handleEvent);
    });
  };
}

var _default = onClickOutside;
exports["default"] = _default;
//# sourceMappingURL=onClickOutside.js.map